import React from "react";

function Experience({ experience }) {
  return (
    <section className="container px-0 my-5">
      <div className="row">
        <div className="col-xs-12 col-md-4 order-1">
          <h2>
            <span className="d-block">Technical Work</span>
            <span className="d-block">Experience</span>
          </h2>
        </div>
        <div className="col-xs-12 col-md-8 order-2">
          {experience.map((job, index) => (
            <div key={index} className="job mb-4">
              <h3 className="h4">{job.title}</h3>
              <p className="company-location mb-0">
                {job.company} | {job.location}
              </p>
              <p className="duration">{job.duration}</p>
              <ul>
                {job.responsibilities.map((item, i) => (
                  <li key={i} className="mb-2">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Experience;
